import { SideBannerProps } from 'apps/frontend/types/Types';
import styles from './sidebanner.module.css';
import { FC } from 'react';
import AdSlot from '../../AdSlot/AdSlot';
import AdSpace from 'apps/frontend/components/AdBlock/adspace';

const SideBanner: FC<SideBannerProps> = ({ size }) => {

  return (
    <>
      {size === 'Small' && (
        <>
          {/* <AdSlot id={'div-gpt-ad-1658152742263-0'} screen={'web'} /> 
          <AdSlot id={'div-gpt-ad-1664454435845-0'} screen={'mobile'} />  */}
          
          <AdSlot id={'div-gpt-ad-1658152742263-0'} screen={'web'} />
          <AdSlot id={'div-gpt-ad-1658153281882-0'} screen={'mobile'} />
          <AdSpace id={'div-Desk_Between_300x250'} width={250} height={250} screen={'web'} />
          <AdSpace id={'div-Mobile_Inner_Page300X250'} width={250} height={250} screen={'mobile'} />
        </>
      )}
      {size === 'Large' && (
        <>
          <div className={styles.largeBanner}>
            <AdSlot id={'div-gpt-ad-1658152770792-0'} screen={'web'} />
            <AdSpace id={'div-Desk_Between_300x600'} width={300} height={480} screen={'web'} />
            <AdSlot id={'div-gpt-ad-1658152230777-0'} screen={'mobile'} />
            <AdSpace id={'div-APP_Bottom_300x250'} width={300} height={50} screen={'mobile'} />
          </div>
        </>
      )}
    </>
  );
};

export default SideBanner;
